import { render, staticRenderFns } from "./RequestDocumentationList.vue?vue&type=template&id=f8e6e78a"
import script from "./RequestDocumentationList.vue?vue&type=script&lang=js"
export * from "./RequestDocumentationList.vue?vue&type=script&lang=js"
import style0 from "./RequestDocumentationList.vue?vue&type=style&index=0&id=f8e6e78a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports